import gql from 'graphql-tag';

export default function (params) {
    return gql`
    mutation{
        assignNode(
        gwid: "${params.gwid}"
        master_gwid: "${params.masterGwid}"
        ){
            errors
            count
            garageGateway{
                id
                device_id
                name
                state
                garage_gateway{
                    id
                    name
                }
            }
        }
    }
    `;
}